<template>
<div class="calendarDetails">
  <div>
    <el-card class="_calendar">
      <el-container>
        <el-main>
          <el-card>
            <el-calendar v-model="value" :first-day-of-week="7">
              <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
              <template slot="dateCell" slot-scope="{date, data}">
                <div slot="reference" class="div-Calendar" @click="calendarOnClick(data)" @mouseenter="hoverChange(date,data)" @mouseleave="leaveChange(data)">
                  <el-popover
                      placement="right"
                      width="400"
                      trigger="hover">
                      <el-table :data="todayList" :height="300">
                        <el-table-column  property="userName" label="巡检人"></el-table-column>
                        <el-table-column  property="templateName" label="巡检模板名称"></el-table-column>
                        <el-table-column label="巡检计划状态">
                          <template slot-scope="scope">
                            <span :style="{color:scope.row.planStatus==0?'#909399':scope.row.planStatus==1?'#e6a23c':'#67c23a'}">{{scope.row.planStatus==0?'未开始':scope.row.planStatus==1?'进行中':'已结束'}}</span>
                          </template>
                        </el-table-column>
                        <!-- <el-table-column  property="today" label="巡检日期"></el-table-column> -->
                      </el-table>
                        <p :class="data.isSelected ? 'is-selected' : ''" slot="reference" style="height:100%;">
                            {{ data.day.split('-').slice(1).join('-') }}
                            <i :class="[data.isSelected ?'el-icon-check':'']"></i>
                            <!-- <i v-if="_.indexOf(isArrange, data.day)>0" class="el-icon-s-claim"></i> -->
                            <!-- <i class="el-icon-coffee-cup"></i> -->
                        </p>
                    </el-popover>
                </div>
              </template>
            </el-calendar>
          </el-card>
        </el-main>

        <el-aside width="40%" style="overflow: hidden;">
          <el-card>
            <div class="el-calendar__header">
              <div class="el-calendar__title">巡查计划详情</div>
              <!-- <div class="el-calendar__button-group">
                <div class="el-button-group">
                  <button
                    type="button"
                    class="el-button el-button--plain el-button--mini"
                    @click="saveOnClick"
                  >
                    <span>新增</span>
                  </button>
                </div>
              </div> -->
            </div>
            <div class="calendar-info" :style="styleObject">
              <div style="padding:0 15px;over-flow:auto;">
                <div v-for="(item,index) in dataList" :key="index">
                  <div role="alert" class="el-alert el-alert--success is-dark" v-if="item.planStatus==2" @click="infoOnClick">
                    <i class="el-alert__icon el-icon-success is-big"></i>
                    <div class="el-alert__content">
                      <span class="el-alert__title is-bold">{{timeInit.getYMD(value)}}{{item.planStatus==2?"（已结束）":item.planStatus==1?"（进行中）":"（未开始）"}}</span>
                      <p class="el-alert__description">巡检人员：{{item.userName}}</p>
                      <p class="el-alert__description">巡检模板名称：{{item.templateName}}</p>
                      <!-- <i class="el-alert__closebtn el-icon-close" @click.stop="infoDel"></i> -->
                    </div>
                  </div>
                  <div role="alert" class="el-alert el-alert--info is-dark" v-if="item.planStatus==0" @click="infoOnClick">
                    <i class="el-alert__icon el-icon-info is-big"></i>
                    <div class="el-alert__content">
                      <span class="el-alert__title is-bold">{{timeInit.getYMD(value)}}{{item.planStatus==2?"（已结束）":item.planStatus==1?"（进行中）":"（未开始）"}}</span>
                      <p class="el-alert__description">巡检人员：{{item.userName}}</p>
                      <p class="el-alert__description">巡检模板名称：{{item.templateName}}</p>
                      <!-- <i class="el-alert__closebtn el-icon-close"></i> -->
                    </div>
                  </div>
                  <div role="alert" class="el-alert el-alert--warning is-dark" v-if="item.planStatus==1" @click="infoOnClick">
                    <i class="el-alert__icon el-icon-warning is-big"></i>
                    <div class="el-alert__content">
                      <span class="el-alert__title is-bold">{{timeInit.getYMD(value)}}{{item.planStatus==2?"（已结束）":item.planStatus==1?"（进行中）":"（未开始）"}}</span>
                      <p class="el-alert__description">巡检人员：{{item.userName}}</p>
                      <p class="el-alert__description">巡检模板名称：{{item.templateName}}</p>
                      <!-- <i class="el-alert__closebtn el-icon-close"></i> -->
                    </div>
                  </div>
                  <!-- <div role="alert" class="el-alert el-alert--error is-dark" @click="infoOnClick">
                    <i class="el-alert__icon el-icon-error is-big"></i>
                    <div class="el-alert__content">
                      <span class="el-alert__title is-bold">错误提示的文案</span>
                      <p class="el-alert__description">文字说明文字说明文字说明文字说明文字说明文字说明</p>
                      <i class="el-alert__closebtn el-icon-close"></i>
                    </div>
                  </div> -->
                </div>
                <div v-if="dataList.length==0" class="noneData">
                  <span>暂无数据</span>
                </div>
              </div>
            </div>
          </el-card>
        </el-aside>
      </el-container>
    </el-card>
    <!-- <calendarDrawer ref="calendarDrawer"></calendarDrawer> -->
    <!-- <calendarForm ref="calendarForm"></calendarForm> -->
  </div>
</div>
</template>

<script>
// import calendarDrawer from "./calendar-drawer.vue";
// import calendarForm from "./calendar-form.vue";
export default {
  // components: { calendarDrawer, calendarForm },
  data: function () {
    return {
      styleObject: {
        height: ""
      },
      value: new Date(),
      // isArrange: [
      //   "2020-06-08",
      //   "2020-06-09",
      //   "2020-06-10",
      //   "2020-06-11",
      //   "2020-06-17",
      //   "2020-06-18"
      // ],
      dataList:[],
      todayList:[],
      hoverShow:false
    };
  },
  created: function () {
    this.getToday(this.timeInit.getYMD(this.value))
    this.makeheight()
    this.$nextTick(() => {
      // 点击前一个月
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      prevBtn.addEventListener("click", () => {
        console.log(this.value);
        this.getToday(this.timeInit.getYMD(this.value))
        // this.$notify({
        //   title: "上一月",
        //   message: "上个月头天：" + this.value,
        //   type: "success",
        //   position: "top-left"
        // });
      });

      //点击下一个月
      let nextBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      nextBtn.addEventListener("click", () => {
        console.log(this.value);
        this.getToday(this.timeInit.getYMD(this.value))
        // this.$notify({
        //   title: "下一月",
        //   message: "下个月头天：" + this.value,
        //   type: "warning",
        //   position: "top-left"
        // });
      });

      //点击今天
      let todayBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      todayBtn.addEventListener("click", () => {
        console.log(this.value);
        this.getToday(this.timeInit.getYMD(this.value))
        // this.$notify.info({
        //   title: "今天",
        //   message: "今天：" + this.value,
        //   position: "top-left"
        // });
      });
    });
  },
  mounted: function () {},
  methods: {
    getToday(data) {//当天巡检详细数据
      let params = {
        date: data
      }
      this.request.postParamsData("/front/polling/plan/getPlanDetailList", params).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.dataList=res.data
        } else if (res.code == 500) {
          this.msg.warn(res.msg);
          this.dataList=[]
        }
      })
    },
    getTodayHover(data) {//鼠标悬浮通过时间获取当天所有的巡检状态
      let params = {
        date: data
      }
      this.request.postParamsData("/front/polling/plan/getPlanByDate", params).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.todayList=res.data
          this.todayList.forEach(item=>{
            item.today=data
          })
        } else if (res.code == 500) {
          // this.msg.warn(res.msg);
          this.todayList=[]
        }
      })
    },
    hoverChange(date,data) {
      console.log(date);
      console.log(data);
      this.hoverShow=data.isSelected
      this.getTodayHover(data.day)
    },
    leaveChange(data) {
      console.log(22);
      this.hoverShow=false
    },
    //点击日期块
    calendarOnClick(data) {
      console.log(data);
      this.getToday(data.day)
      // this.isArrange.push("2020-06-19");
      // this.$notify.error({
      //   title: "日历块点击",
      //   message: data,
      //   position: "top-left"
      // });
    },
    //点击信息块
    infoOnClick() {
      // this.$refs.calendarDrawer.drawer = true;
    },
    //新增排班
    saveOnClick() {
      // this.$refs.calendarForm.dialogFormVisible = true;
    },
    //删除排班
    infoDel() {
      this.$confirm("此操作将永久删除该排班, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 210) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.is-selected {
  color: #1989fa;
}

.p-popover {
  text-align: center;
}

._calendar {
  height: 99.5%;
  width: 100%;
}

.el-main {
  padding: 0px;
  overflow: hidden;
}

.calendar-info {
  position: relative;
  /* height: 94%; */
  padding-bottom: 20px;
  overflow: auto;
  /* box-sizing: border-box; */
}

.el-alert {
  margin: 15px 0px;
}

.el-alert:hover {
  transform: scale(1.02);
}

.el-alert:active {
  transform: scale(1.01);
}
.noneData{
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -50px;
  margin-top: -50px;
  z-index: 10;
  span{
    color:#aaa;
    font-size: 24px;
  }
}
.div-Calendar {
  position: relative;
  p{
    border: none;
    outline: none;
  }
}
</style><style lang="scss">
._calendar .div-Calendar {
  height: 115px;
  box-sizing: border-box;
  padding: 8px;
}

._calendar .el-calendar-table .el-calendar-day {
  padding: 0px;
  height: 115px;
}

._calendar .el-container,
._calendar .el-calendar {
  height: 100%;
}

._calendar .el-card__body {
  padding: 0px;
}
</style>
